export default __webpack_public_path__ + "static/s9-b364f20aa7e375961366f8fb849f4a74.jpg";